import './index.scss';

export default class JobofferDetail {
    constructor(root) {
        this.root = root;
        this.buttonControls = root.querySelector('.button_controls');
        this.init();
    }

    init() {
        if (!this.buttonControls) {
            return;
        }

        document.body.classList.add('has-joboffer-button-controls');

        const updateHeight = () => {
            const height = this.buttonControls.offsetHeight;
            if (height > 0) {
                document.documentElement.style.setProperty(
                    '--joboffer-button-controls-height',
                    `${height}px`
                );
            }
        };

        updateHeight();
        window.addEventListener('resize', updateHeight);
        setTimeout(updateHeight, 100);
    }
}

window.app.run(() => {
    document.querySelectorAll('[data-joboffer-detail]').forEach((node) => {
        new JobofferDetail(node);
    });
});
